import { render, staticRenderFns } from "./CardLunBo.vue?vue&type=template&id=6c919f86&scoped=true&"
import script from "./CardLunBo.vue?vue&type=script&lang=js&"
export * from "./CardLunBo.vue?vue&type=script&lang=js&"
import style0 from "./CardLunBo.vue?vue&type=style&index=0&id=6c919f86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c919f86",
  null
  
)

export default component.exports